export const ENDPOINTS_ROUTES = {
  GET_CATEGORIES: () => "/categories",
  GET_RV_CATEGORIES: () => "/rv/portfolio/category",
  GET_PARTNERS: () => "/partners",
  GET_BANNERS: () => "/banners/highlight",
  GET_BENEFITS: () => "/benefits",
  GET_PARTNERS_BENEFITS: () => "/partner-benefit",
  GET_CATEGORY_PARTNER_ACTIVE: () => "/category-partner/active",
  GET_LOCATION: () => "/location/:zipCode",

  GET_PROVIDERS: () => "/rv/portfolio/providers/actived",
  GET_PORTFOLIO_DETACH: () => "/rv/portfolio/destaque/ativo",

  SAVED_CELLPHONES: () => "/user/cellphone-topups/saved-cellphone",

  POST_CELLPHONES_VALUES: () => "/rv/portfolio/providers/cellphone-values",

  CELLPHONE_TOPUPS_TRANSACTIONS: () => "/rv/cellphone-topups/transactions",
  TV_TOPUPS_TRANSACTIONS: () => "/rv/tv-topups/transactions",
  PIN_TOPUPS_TRANSACTIONS: () => "/rv/pin-topups/transactions",

  POST_PIX: () => "/pix/rv/cobranca",
  GET_PIX: () => "/pix",
  PIX_PAID: () => "/pix/rv/pago",

  GET_CUSTOM_IMAGE_BY_PROVIDER: () => "/rv/portfolio/providers/logo-custom",
  GET_IMAGE_BY_PROVIDER: () => "/rv/portfolio/providers/logo",
  TV_SAVED_SIGNERCODE: () => "/user/tv-topups/saved-signercode",

  GET_TV_OFFERS: () => "/rv/portfolio/tv/providers/offers",
  GET_TV_OFFER: () => "/rv/portfolio/tv/providers/offer",

  GET_TV_VALUES: () => "/rv/portfolio/providers/cart/tv-values",
  GET_CELLPHONE_VALUES: () => "/rv/portfolio/providers/cart/cellphone-values",

  GET_PIN_ORIENTATION: () => "/rv/portfolio/providers/pin/orientacao",
  GET_PIN: () => "/rv/portfolio/providers/pin/",
  GET_PIN_VALUES: () => "/rv/portfolio/pin/providers/values",
  GET_PIN_CART_VALUES: () => "/rv/portfolio/providers/cart/pin-values",

  USER_EMAIL: () => "/user/saved-email",
  GET_TERMS: () => "/rv/portfolio/providers/termos",

  GET_PRODUCTS: () => "/rv/portfolio/filter/category",
};
